const api = {
     BgColor : 'white',
     TextColor : 'dark'
}

export const BgColor = api.BgColor;
export const TextColor = api.TextColor;

